import { createContext, useContext, useEffect, useState } from 'react';

const ThemeContext = createContext(null);
const VALID_THEMES = ['dark', 'light', 'contemplativo'];

export const ThemeProvider = ({ children }) => {
  const [theme, setThemeState] = useState(() => {
    const saved = localStorage.getItem('cgpt-theme');
    return VALID_THEMES.includes(saved) ? saved : 'dark';
  });

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    // 'contemplativo' também é um tema de fundo escuro — mantém utilitários dark: do Tailwind ativos
    document.documentElement.classList.toggle('dark', theme !== 'light');
    localStorage.setItem('cgpt-theme', theme);
  }, [theme]);

  const toggleTheme = () => setThemeState(t => (t === 'dark' ? 'light' : 'dark'));
  const setTheme = (t) => {
    if (VALID_THEMES.includes(t)) setThemeState(t);
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
